import AdminProductsCard from './AdminProductsCard';

export default AdminProductsCard;
